/* eslint-disable */

import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import FlexRow from "../flex-row/flex-row.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";
import RaindropTextHeading1 from "../raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import Spacer from "../spacer/spacer.js";
import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import FlexCol from "../flex-col/flex-col.tsx";
import { useState } from "react";
import { warning } from "framer-motion";

const RaindropCardWarning = ({
  title = "Warning",
  body = "This is the body",
  primaryLabel = null,
  onPrimaryAction = null,
}) => {
  const [isDismissed, setIsDismised] = useState(false);

  if (isDismissed) {
    return null;
  }

  return (
    <RaindropCard>
      <FlexCol className="text-left w-full">
        <FlexRow>
          <i className="fa fa-warning text-3xl text-color-raindrop-primary" />
          <RaindropTextHeading1>{title}</RaindropTextHeading1>
          <Spacer />
          <RaindropButton
            icon="fa-xmark"
            style={ButtonStyle.Icon}
            onClick={() => setIsDismised(true)}
          />
        </FlexRow>
        <RaindropTextSubtitle className="w-full">{body}</RaindropTextSubtitle>

        {primaryLabel && (
          <FlexRow className="flex-row-reverse">
            <RaindropButton
              style={ButtonStyle.Outline}
              title={primaryLabel}
              onClick={onPrimaryAction}
            />
          </FlexRow>
        )}
      </FlexCol>
    </RaindropCard>
  );
};

export default RaindropCardWarning;
